import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 36.29 62.58",
  "content": "<symbol viewBox=\"0 0 36.29 62.58\" id=\"icon-arrow-left\">\r\n    <path d=\"M34.83,61.12a5,5,0,0,0,0-7.07L12.07,31.29,34.83,8.53a5,5,0,1,0-7.07-7.07L1.47,27.76a5,5,0,0,0,0,7.07L27.76,61.12a5,5,0,0,0,7.07,0\" transform=\"translate(0 0)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/arrow-left.svg
// module id = ./app/general/svg/arrow-left.svg
// module chunks = app